import $ from 'jquery';
import config from './../../../../config';

export function invite_candidate( data ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/onboard/',
			data: {
                method: 'CANDIDATE_INVITE',
				data: data
            }
		})
		.then(function (response) {
			dispatch({
				type: "CANDIDATE_INVITE",
				onboard: response
			})
		})

	}
}

export function get_company(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/onboard/',
			data: {
                method: 'CANDIDATE_GET_COMPANY',
            }
		})
		.then(function (response) {
			dispatch({
				type: "CANDIDATE_GET_COMPANY",
				onboard: response
			})
		})

	}
}

export function get_department(){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/onboard/',
			data: {
                method: 'CANDIDATE_GET_DEPARTMENT',
            }
		})
		.then(function (response) {
			dispatch({
				type: "CANDIDATE_GET_DEPARTMENT",
				onboard: response
			})
		})

	}
}

export function get_candidate( user_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/onboard/',
			data: {
				method: 'GET_CANDIDATE',
				user_id: user_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "GET_CANDIDATE",
				onboard: response
			})
		})

	}
}


export function set_candidate_convert( user_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/onboard/',
			data: {
				method: 'SET_CANDIDATE_CONVERT',
				user_id: user_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "SET_CANDIDATE_CONVERT",
				onboard: response
			})
		})

	}
}


export function checklist_request( user_id ){
	return dispatch => {

		$.ajax({
			method: 'GET',
			url: config.apiurl + 'requests/onboard/',
			data: {
				method: 'REQUEST_CHECK_LIST',
				user_id: user_id
            }
		})
		.then(function (response) {
			dispatch({
				type: "REQUEST_CHECK_LIST",
				onboard: response
			})
		})

	}

}

export function update_checklist_value( checklist_id, value ){
	return dispatch => {

		$.ajax({
			method: 'GET',
            url: config.apiurl + 'requests/onboard/',
            data: {
				method: 'CANDIDATE_UPDATE_CHECK_VALUE',
				checklist_id: checklist_id,
				value: value
            }
		})
		.then(function (response) {
			dispatch({
				type: "CANDIDATE_UPDATE_CHECK_VALUE",
				onboard: response
			});
		});

	}

}


// WEBPACK FOOTER //
// ./src/pages/requests/onboarding/actions/onboard.action.js